import React, { useEffect, useState, useMemo } from "react";
import CountUp from "react-countup";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { decodeHtml } from "../../../utils/decodeHtml";
import RevenueRiskEntity from "../../order/components/RevenueRiskEntity";
import RevenueRiskClient from "../../order/components/RevenueRiskClient";
import RevenueRiskMember from "../../order/components/RevenueRiskMember";
import { colors } from "@mui/material";
function InvoiceAtrisk() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const {setGlobalLoading, token } = useOutletContext();
  
  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_atrisk_data/`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setOptions(response.data.risk_invoice_items_list || []);
       
        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
    } finally {
        setGlobalLoading(false); 
    }
  }

  useEffect(() => {
    if (token) {
        fetchOptions();
    }
  }, [token]); 
  const columns = [
        {
        accessorKey: "name",
        header: "Name",
        size: 70,
        },
        {
        accessorKey: "role_name",
        header: "Role Name",
        size: 70,
        Cell: ({ row }) => (
            <Link
              to={`/role/view/${row.original.role_id}`}
            >
            {decodeHtml(row.original.role_name)}
            </Link>
        ),
        },
        {
        accessorKey: "company_name",
        header: "Clients",
        size: 70,
        },
        {
        accessorKey: "bdBy",
        header: "Business Developed",
        size: 70,
        },
        {
        accessorKey: "roleManager",
        header: "Role Manager",
        size: 70,
        },
        {
        accessorKey: "assignedTo",
        header: "Assigned To",
        size: 70,
        },
        {
        accessorKey: "entity",
        header: "Entity",
        size: 40,
        },
        {
        accessorKey: "status",
        header: "Status",
        size: 40,
        },
        {
        accessorKey: "reporting_date",
        header: "Reporting",
        size: 70,
        },
        {
        accessorKey: "raised_date",
        header: "Raised On",
        size: 70,
        },
        {
        accessorKey: "days",
        header: "Days",
        size: 70,
        },
        {
        accessorKey: "major_industry",
        header: "Industry",
        size: 70,
        },
        {
        accessorKey: "region",
        header: "Region",
        size: 70,
        },
        {
        accessorKey: "amount",
        header: "Amount",
        size: 70,
        },
        {
        accessorKey: "revenue",
        header: "Total(INR)",
        size: 70,
        Cell: ({ row }) => currency_converter_inr(row.original.revenue),
        },
    ];  

    const exportToExcel = () => {
    const exportData = options.map((row) => ({
        Name: row.name,
        "Role Name": decodeHtml(row.role_name),
        Client: row.company_name,
        "Business Developed": row.bdBy,
        "Role Manager": row.roleManager,
        "Assigned To": row.assignedTo,
        Entity: row.entity,
        Status: row.status,
        "Reporting": row.reporting_date,
        "Raised On": row.raised_date,
        Days: row.days,
        Industry: row.major_industry,
        Region: row.region,
        Amount: row.amount,
        "Total (INR)": row.revenue,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "At Risk Invoices"
    );

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
    });

    const file = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, `AtRiskInvoices_${new Date().getTime()}.xlsx`);
    };


    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 700px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 100px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 200px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          } 
        .client-column {
            width: 70%;
            white-space: normal !important;
            word-break: break-word;
            }

        .amount-column {
            width: 30%;
            white-space: nowrap;
            } 
        .sticky-summary td {
            position: sticky;
            top: 22px;      /* Height of the header */
            background: #e9ecef;
            z-index: 20;
            font-weight: bold;
        }      
        `}
        </style>  
  
        <div className="card shadow-sm mb-4">
        <div className="card-body">
            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-0">
                    At Risk Invoices
                </h5>
            </div>
            <div className="border-0">
                <div className="row">
                    <div className="col-xxl-12 d-flex">
                        <div className="row flex-fill">
                        <div className="col-md-3 d-flex">
                            <div className="card flex-fill">
                            <div className="card-body">
                                <h3 className="d-flex fs-17 mb-2" style={{ flexDirection: "row" }}>
                                <span className="avatar rounded-circle bg-purple mb-1 me-2">
                                    <i className="fa-solid fa-money-bills"></i>
                                </span>
                                <div className="d-flex" style={{ flexDirection: "column", justifyContent: "space-evenly"}}>
                                    <span className="fw-lighter">Total At Risk</span>
                                    <span>{currency_converter_inr(data?.atrisk_invoices?.[0]?.revenue)}</span>
                                </div>
                                </h3>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex">
                            <div className="card flex-fill div-focus-border">
                            <div className="card-body">
                                <h3 className="d-flex fs-17 mb-3" style={{ flexDirection: "row" }}>
                                <span className="avatar rounded-circle bg-pink mb-1 me-2">
                                    <i className="fa-solid fa-file-invoice"></i>
                                </span>
                                <div className="d-flex" style={{flexDirection: "column", justifyContent: "space-evenly"}}>
                                    <span className="fw-lighter">Not Issued Count</span>
                                    <span>{data?.atrisk_invoices?.[0]?.invoiceCount}</span>
                                </div>
                                </h3>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex">
                            <div className="card flex-fill">
                            <div className="card-body">
                                <h3 className="d-flex fs-17 mb-3" style={{ flexDirection: "row" }}>
                                <span className="avatar rounded-circle bg-warning mb-1 me-2">
                                    <i className="fa-solid fa-arrow-trend-down"></i>
                                </span>
                                <div className="d-flex" style={{flexDirection: "column", justifyContent: "space-evenly"}}>
                                    <span className="fw-lighter">YoY Change</span>
                                    <span> {data?.yoy_change?.[0]?.yoyPercentage}%</span>
                                </div>
                                </h3>
                                <div className="d-flex align-items-center">
                                <span className="fw-10">Previous year: {currency_converter_inr(data?.yoy_change?.[0]?.previousYearRevenue)}</span>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex">
                            <div className="card flex-fill">
                            <div className="card-body">
                                <h3 className="d-flex fs-17 mb-3" style={{ flexDirection: "row" }}>
                                <span className="avatar rounded-circle bg-secondary mb-1 me-2">
                                    <i className="fa-solid fa-triangle-exclamation"></i>
                                </span>
                                <div className="d-flex" style={{flexDirection: "column", justifyContent: "space-evenly"}}>
                                    <span className="fw-lighter">Avg Risk per Invoice</span>
                                    <span>{data?.atrisk_invoices?.[0]?.avgRiskPerInvoice}L</span>
                                </div>
                                </h3>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 d-flex">
                        <div className="card flex-fill">
                        <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                            <h5 className="mb-2">Risk by Entity</h5>
                        </div>
                        <div className="card-body">
                            <RevenueRiskEntity
                            chart_data={data?.risk_by_entity}
                            />
                        </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-flex">
                    <div className="card flex-fill" style={{ height: "400px" }}>
                        <div className="card-header pb-2">
                        <h5 className="mb-0">Split by Client</h5>
                        </div>
                        <div className="card-body d-flex flex-column p-2" style={{ height: "300px" }}>
                        <RevenueRiskClient
                            chart_data={data?.revenue_risk_client}
                        />
                        </div>
                    </div>
                    </div>
                    <div className="col-md-4 d-flex">
                    <div className="card flex-fill" style={{ height: "400px" }}>
                        <div className="card-header pb-2">
                        <h5 className="mb-0">Split by Team Member</h5>
                        </div>
                        <div className="card-body d-flex flex-column p-2" style={{ height: "300px" }}>
                        <RevenueRiskMember
                            chart_data={data?.revenue_risk_member}
                        />
                        </div>
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="card">
                    <div className="card-body p-0">
                        <div className="custom-datatable-filter table-responsive">
                        <div className="d-flex justify-content-end mb-1">
                        <button className="btn btn-sm btn-success" onClick={exportToExcel}>
                            <i className="fa fa-file-excel me-2"></i>
                            Export Excel
                        </button>
                        </div>
                        <div className="row p-1 mt-0">
                            {options.length > 0 && (
                            <MaterialReactTable
                                columns={columns}
                                data={options}
                                enableGrouping
                                muiTableBodyRowProps={({ row }) => {
                                const days = Number(row.original?.days) || 0;

                                let bgColor = "";

                                if (days >= 15 && days <= 60) {
                                    bgColor = "#FCFCB2";
                                } else if (days > 60 && days <= 90) {
                                    bgColor = "#FFD485";
                                } else if (days > 90) {
                                    bgColor = "#FDAFAF";
                                }

                                return {
                                    sx: {
                                    backgroundColor: bgColor,
                                    },
                                };
                                }}
                                initialState={{
                                density: "compact",
                                grouping: ["company_name"], // group by company_name
                                expanded: true,
                                // expanded: {}, // expand groups by default
                                pagination: { pageSize: 100 },
                                columnOrder: [
                                    "name",
                                    "role_name",
                                    "company_name",
                                    "bdBy",
                                    "roleManager",
                                    "assignedTo",
                                    "entity",
                                    "status",
                                    "reporting_date",
                                    "raised_date",
                                    "days",
                                    "major_industry",
                                    "region",
                                    "amount",
                                    "revenue",
                                ],
                                columnPinning: {
                                    left: [], // 👈 no pinned columns
                                    right: [],
                                },
                                }}
                            />
                            )}
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

        </>
    );
}

export default InvoiceAtrisk;
